import { List, ListX } from "lucide-react";

import { Button } from "components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

export function ToggleLegendButton({ isShowing = false, onToggle }) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant={isShowing ? "secondary" : "outline"}
            size="icon"
            aria-label={isShowing ? "Hide legend" : "Show legend"}
            onClick={onToggle}
          >
            {isShowing ? (
              <ListX data-icon="inline-start" />
            ) : (
              <List data-icon="inline-start" />
            )}
          </Button>
        }
      />
      <TooltipContent>
        {isShowing ? "Hide legend" : "Show legend"}
      </TooltipContent>
    </Tooltip>
  );
}
